import { Tooltip } from '@chakra-ui/react';
import { ReactComponent as UserSolidIcon } from 'resources/images/user-solid.svg';
import { AvatarDefault, AvatarDefaultProps } from './AvatarDefault';

export const AvatarWithTooltip = (props: AvatarDefaultProps) => {
  const { index, usersLength, userCard } = props;

  return (
    <Tooltip
      label={userCard.displayName}
      shouldWrapChildren
      wordBreak="break-all"
    >
      <AvatarDefault
        {...props}
        tabIndex={index}
        cursor="default"
        zIndex={usersLength - index}
        ml={index === 0 ? 0 : -0.5}
        {...(userCard.initials
          ? {}
          : {
              color: 'B.80',
              bg: 'B.60',
            })}
        icon={
          <UserSolidIcon
            color="B.80"
            width={25}
            height={25}
            style={{ margin: 'auto' }}
          />
        }
        _hover={{ border: '1px solid' }}
      />
    </Tooltip>
  );
};
